<template>
  <vue-slider
    :max="safeMaxTime"
    :value="[0, safeMaxTime]"
    v-bind="options"
    class="time-slider time-position-select"
    @change="$emit('change', $event)"
  >
  </vue-slider>
</template>

<script>
import VueSlider from "vue-slider-component";
import TimeSliderMixin from "@/components/sliders/TimeSliderMixin.vue";

// @group Sliders
// Slider for selecting start-end time
export default {
  name: "FlexTimeSlider",
  components: {
    VueSlider
  },
  mixins: [TimeSliderMixin],
  props: {
    /** Max time value */
    maxTime: {
      type: Number,
      required: true,
      validator(val) {
        return Number.isFinite(val);
      }
    }
  },
  computed: {
    safeMaxTime() {
      return Math.max(0, Math.floor(this.maxTime * 1000) / 1000);
    }
  },
  data() {
    return {
      options: {
        width: "100%",
        min: 0,
        interval: 0.001,
        tooltipFormatter: this.getTime,
        processStyle: {
          "background-color": "#13d413"
        },
        dotStyle: {
          width: "3px",
          "border-radius": "0",
          "background-color": "#13d413",
          "box-shadow": "none"
        }
      }
    };
  }
};
</script>

<style scoped>
.time-slider {
  width: 100%;
}
</style>

<style>
.time-position-select .vue-slider-dot.vue-slider-dot-hover {
  width: 3px !important;
}
</style>
